export enum SupplierVendorType {
  MEDIA_OWNER = "Media Owner",
  PRINTER = "Printer",
  ELECTRICAL = "Electrical",
}
